import React, { ReactNode } from 'react';
import { Box, CircularProgress } from '@mui/material';
import useGoogleMapsLoader from '../../../hooks/useGoogleMapsLoader';

interface MapWrapperProps {
  children: ReactNode;
}

const MapWrapper = ({ children }: MapWrapperProps) => {
  const { isLoaded } = useGoogleMapsLoader();

  if (!isLoaded) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  return <>{children}</>;
};

export default MapWrapper;
